<template>
  <div class="landing-container">
    <!-- Partie Gauche avec illustration -->
    <div class="left-panel">
      <img src="img/aloha-default.png" alt="Aloha Visual" class="illustration" />
    </div>

    <!-- Partie Droite avec Formulaire -->
    <div class="right-panel">
      <div class="login_center">
        <form class="form-horizontal login-form" v-on:submit.prevent="connect()" method="post">
          <div class="login-logo">
            <img src="img/logo_ideal_hor.png" alt="Ideal Solutions" />
          </div>
          <div class="login-fields">
            <div id="login-status"></div>
            <div class="input-group">
              <span class="input-group-addon"><i class="fas fa-user"></i></span>
              <input type="text" class="form-control" id="email" placeholder="Login" v-model="post.email" required />
            </div>
            <div class="input-group">
              <span class="input-group-addon"><i class="fas fa-lock"></i></span>
              <input type="password" class="form-control" id="pwd" placeholder="Mot de passe" v-model="post.pwd" required />
            </div>
            <input type="submit" class="btn btn-primary btn-block" value="Connexion" />
            <div class="mt-3">
              <a v-on:click.prevent="openModal($event.target)" data-toggle="modal" href="#modalMdpOublie">Mot de passe oublié ?</a>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal d'oubli de mot de passe -->
    <b-modal id="modalOublieMDP" @hide="resetModal" :title="modalOublieMDP.title" hide-footer>
      <b-form>
        <b-form-group id="input-group-login" label="Veuillez entrer votre login :" label-for="input-login">
          <b-form-input type="email" id="input-login" v-model="loginOublie"></b-form-input>
        </b-form-group>
        <b-button id="sendChangePass" block v-on:click="changePassOublie" variant="primary">Envoyer</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import conf from '../config/api.js';
import script from '../script/script.js';

export default {
    data() {
        return {
            post: {},
            modalOublieMDP: { title: "Formulaire d'oubli de mot de passe", content: '' },
            loginOublie:""
        }
    },
    created:function(){
      this.isConnect();
    },
    methods: {
        connect() {
            this.axios.post(conf.server+"/api/connect", this.post,{withCredentials:true})
            .then((response) => {
                if(response.status==200) {
                    if (this.$route.query.redirect) {
                        this.$router.push(this.$route.query.redirect)
                    }
                    else {
                        this.$router.push(response.data.route);
                    }
                }
                else{
                    this.$router.push('/');
                }
            })
            .catch((error) => {
              console.log(error)
                this.$bvToast.toast(`Identifiant ou mot de passe incorrect`, {
                    title: 'Identification',
                    toaster: 'b-toaster-bottom-right',
                    variant: 'danger',
                    autoHideDelay: 5000,
                    appendToast: true,
                    solid: true,
                })
            })
        },
        isConnect: script.isConnect,
        openModal(target){
          this.$root.$emit('bv::show::modal', 'modalOublieMDP',target);
        },
        changePassOublie: script.changePassOublie
    }
}
</script>

<style scoped>
.landing-container {
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: #0f1e3d;
  overflow: hidden;
}

.left-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4c68d7, #5cc3ff);
  max-width: 60%;
}

.right-panel {
  flex: 1;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login_center {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
}

.login-logo img {
  display: block;
  margin: 0 auto 20px auto;
  max-width: 150px;
}

.login-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input-group {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px 12px;
}

.input-group-addon {
  color: #333;
  margin-right: 8px;
}

.form-control {
  border: none;
  outline: none;
  flex: 1;
  font-size: 16px;
}

.btn-primary {
  background-color: #4c68d7;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
}

.btn-primary:hover {
  background-color: #3b55b2;
}
</style>


